import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() { }

  propertyCollection = ['State', 'UserRole', 'CarrierId', 'CarrierName', 'PackageId'];

  logRequestTime(requestBeginTime: number, request: HttpRequest<any>) {
    const requestDuration = `${performance.now() - requestBeginTime}`;
    const urlObject = new URL(request.url);
    console.log(`HTTP ${request.method} ${urlObject.pathname} ${this.extractBodyParams(request)} - ${parseFloat(requestDuration).toFixed(2)} milliseconds`);
  }

  extractBodyParams(request) {
    let message = '';
    if (request.body) {
      let requestedBody = this.tryParseJSONObject(request.body) ? JSON.parse(request.body) : request.body;
      if (requestedBody) {
        this.propertyCollection.forEach(element => {

          let returnedValue = this.propertyLookUp(requestedBody, element);
          if (returnedValue && returnedValue.length > 0) {
            let output = `${element}: ${returnedValue[1]}`;
            message += (message === '') ? output : `, ${output}`;
          }
        });
      }
    }
    return message;
  }

  tryParseJSONObject(jsonString) {
    try {
      var o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      if (o && typeof o === "object") {
        return o;
      }
    }
    catch (e) { }

    return false;
  };

  propertyLookUp(obj, k) {
    for (var key in obj) {
      var value = obj[key];
      if (k == key) {
        return [k, value];
      }
      if (typeof (value) === "object" && !Array.isArray(value)) {
        var y = this.propertyLookUp(value, k);
        if (y && y[0] == k) return y;
      }
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; ++i) {
          var x = this.propertyLookUp(value[i], k);
          if (x && x[0] == k) return x;
        }
      }
    }
    return null;
  }
}
